import "es6-shim";
import "./LanguageSelect.css";
import * as React from 'react';
import { ILanguageSelectionProps } from "./Types";
import { LanguageCodes, LanguageStrings } from "../../constants/languages";

const spImage = require("../../assets/images/es.png");
const enImage = require("../../assets/images/en.png");
const frImage = require("../../assets/images/fr.png");

const languageImageMap = {
    [LanguageCodes.Spanish]: spImage,
    [LanguageCodes.English]: enImage,
    [LanguageCodes.French]: frImage
}

export const LanguageSelection = (props: ILanguageSelectionProps) => {
    const [isSelecting, setIsSelecting] = React.useState(false);
    const revertSelectionModeIfTimeout = setTimeout(() => setIsSelecting(false), 10000);
    React.useEffect(() => {
        if (isSelecting) {
            setIsSelecting(false);
        }
    }, [props.lang]);

    if (props.useableLanguages.size === 1) {
        return null;
    }
    const selectOptions = [];
    const dataToUse = [];
    props.useableLanguages.forEach((code) => {
        selectOptions.push({
            text: LanguageStrings[code],
            value: code
        });
        if (code !== props.lang) {
            dataToUse.push({ code, text: LanguageStrings[code] })
        }
    })

    if (props.useableLanguages.size === 2) {
        return (
            <div className={"language-selection-container"}>
                <table>
                    <tbody>
                        {
                            dataToUse.map((lang, index) => {
                                return (
                                    <LanguageSingleRow
                                        key={"data-to-use-" + index}
                                        value={lang.code}
                                        text={lang.text}
                                        onClick={() => props.changeLang(lang.code)}
                                    />
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    } else {
        return (
            isSelecting ?
                (
                    <LanguageContainer style={{ backgroundColor: "white" }}>
                        {
                            selectOptions.map((opt, index) => (
                                <LanguageSingleRow
                                    key={"lang-option-" + index}
                                    {...opt}
                                    onClick={() => {
                                        if (props.lang !== opt.value) {
                                            props.changeLang(opt.value)
                                        } else {
                                            setIsSelecting(false);
                                        }
                                        clearTimeout(revertSelectionModeIfTimeout);
                                    }}
                                />
                            ))
                        }
                    </LanguageContainer>
                )
                : (

                    <LanguageContainer>
                        <LanguageSingleRow
                            text={LanguageStrings[props.lang]}
                            value={props.lang}
                            onClick={() => setIsSelecting(true)}
                            showCaret={true}
                        />
                    </LanguageContainer>
                )

        );

    }
}

interface ILanguageContainerProps {
    style?: React.CSSProperties;
    children: React.ReactNode;
}

const LanguageContainer = (props: ILanguageContainerProps) => (
    <div className={"language-selection-container"} style={props.style}>
        <table>
            <tbody>
                {props.children}
            </tbody>
        </table>
    </div>
)

interface ILanguageSingleRowProps {
    onClick: () => void;
    showCaret?: boolean;
    value: string;
    text: string;
}

const LanguageSingleRow = (props: ILanguageSingleRowProps) => (
    <tr
        onClick={props.onClick}
    >
        {
            props.showCaret &&
            <td>
                <i className="fas fa-caret-down" />
            </td>
        }
        <td className="text-center" style={{ border: "0" }}>
            <img src={languageImageMap[props.value]} style={{ height: "25px" }} />
        </td>
        <td>
            {props.text}
        </td>
    </tr>
)


// WEBPACK FOOTER //
// ./src/components/LanguageSelection/LanguageSelection.component.tsx